<template>
  <v-container fluid grid-list-xl fill-height>
    <v-layout justify-center align-center>
      <v-flex xs12 sm8 md4>
        <material-card :color="cardColor" title="Quality CMS - Login" :text="message">
          WAITING FOR LOGIN PROCESS...
          <br><v-btn v-if="message" @click="logout">Try login again!</v-btn>
        </material-card>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

// import GoogleLogin from 'vue-google-login';

import { getKeycloak } from '@/utils/keycloak'


export default {
  data: () => ({
    kc: {
      idToken: null,
      accessToken: null
    },
    cardColor: 'primary',
    message: null,
  }),
  mounted() {

    getKeycloak().then(keycloak => {
      this.kc.idToken = keycloak.idToken;
      this.kc.accessToken = keycloak.token;
      this.login()
    })

  },
  methods: {
    login() {
      this.$store
        .dispatch('user/login_with_keycloak', this.kc)
        .then(() => {
          this.cardColor = 'success'
          const path = this.$route.query.redirect || '/'
          this.$router.push({ path })
          this.loading = false
        })
        .catch((e) => {
          this.loading = false
          this.message = e.message
          this.cardColor = 'error'
        })
    },
    logout() {
      this.$store.dispatch("user/logout")
    }
  }
}
</script>


<style scoped>
.form-separator {
  height: 12px;
  margin: 0px 0px 20px 0px;
  text-align: center;
  border-bottom: 1px solid #e4e5e7;
}

.form-separator span {
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  padding: 0 8px;
  background-color: #fff;
  color: #62646a;
}

.googleButton {
  margin: auto;
  min-width: 130px;
  background-color: #f4f4f4;
  border: 1px solid gray;
  text-align: left;
  margin-top: 15px;
}

.googleButton span {
  position: absolute;
  margin-top: 7px;
}
</style>